import { useAppDispatch } from 'hooks/useAppDispatch'
import { increaseQuantity, decreaseQuantity } from 'actions/orders.action'

export interface CartItemProps {
  productId: number
  currency: string
  name: string
  price: number | string | null
  quantity: number
  variantName: string | null
}

export const useCartItem = (props: CartItemProps) => {
  const { productId, variantName } = props

  const dispatch = useAppDispatch()

  const handleIncrease = () => {
    dispatch(increaseQuantity(productId, variantName))
  }

  const handleDecrease = () => {
    dispatch(decreaseQuantity(productId, variantName))
  }

  return {
    ...props,
    handleIncrease,
    handleDecrease,
  }
}
